import { formatDoNotCurrentlyOwnRentExplanation } from 'hooks/mutations/useSavePrimaryFormMutation.utils';

export const MAX_EXPLAIN_THE_SITUATION_LENGTH = 255;

const EXPLAIN_THE_SITUATION = 'explainTheSituation';

const PHONE_NUMBER_DIGITS = 10;

const getNamePrefix = (name = EXPLAIN_THE_SITUATION) =>
  name.slice(0, -EXPLAIN_THE_SITUATION.length);

export const getExplainTheSituationWatchFields = (name) =>
  [
    'residence',
    'canContactToVerifySituation',
    'contactName',
    'relationshipToYou',
    'phoneNumber',
  ].map((fieldName) => `${getNamePrefix(name)}${fieldName}`);

const getContactPrefixLength = ({
  canContactToVerifySituation,
  contactName,
  phoneNumber,
  relationshipToYou,
  residence,
}) =>
  formatDoNotCurrentlyOwnRentExplanation({
    canContactToVerifySituation,
    contactName,
    explainTheSituation: '',
    ownOrRentOrNotCurrently: residence,
    phoneNumber,
    relationshipToYou,
  }).length;

const getHasContactDetails = ({ phoneNumber, relationshipToYou }) =>
  Boolean(relationshipToYou?.trim()) &&
  String(phoneNumber ?? '').replace(/\D/g, '').length >= PHONE_NUMBER_DIGITS;

export const getExplainTheSituationOverflow = ({
  explainTheSituation,
  ...contactValues
}) => {
  const maxAllowed =
    MAX_EXPLAIN_THE_SITUATION_LENGTH - getContactPrefixLength(contactValues);

  return {
    maxAllowed,
    excess: (explainTheSituation?.length ?? 0) - maxAllowed,
  };
};

export const getExplainTheSituationLengthError = ({
  getValues,
  intl,
  name,
  value,
}) => {
  const namePrefix = getNamePrefix(name);
  const getResidenceValue = (fieldName) =>
    getValues?.(`${namePrefix}${fieldName}`);
  const contactValues = {
    canContactToVerifySituation: getResidenceValue(
      'canContactToVerifySituation',
    ),
    contactName: getResidenceValue('contactName'),
    phoneNumber: getResidenceValue('phoneNumber'),
    relationshipToYou: getResidenceValue('relationshipToYou'),
    residence: getResidenceValue('residence'),
  };

  if (
    getContactPrefixLength(contactValues) > 0 &&
    !getHasContactDetails(contactValues)
  ) {
    return '';
  }

  const { excess, maxAllowed } = getExplainTheSituationOverflow({
    ...contactValues,
    explainTheSituation: value,
  });

  if (excess <= 0) {
    return '';
  }

  if (maxAllowed <= 0) {
    return intl.formatMessage({
      id: 'app.toast.error.situation.maxLength.contactTooLong',
    });
  }

  return intl.formatMessage(
    { id: 'app.toast.error.situation.tooLong' },
    { excess },
  );
};
